import React from "react";
import communityImg from "../assets/community_new.png";
import watermarkLogo from "../assets/wamglammz-logo.png";

export default function Community() {
    return (
        <section className="relative w-full overflow-hidden bg-[#1A73E8] py-20 md:py-28 font-sans">

            {/* CONTENT CONTAINER */}
            <div className="relative z-10 w-[90%] max-w-[1600px] mx-auto flex flex-col md:flex-row items-center justify-between gap-12">

                {/* LEFT COLUMN - TEXT */}
                {/* Increased max-w slightly to allow the larger text to flow naturally */}
                <div className="relative z-20 w-full max-w-[550px] text-left">
                    <p className="text-[14px] tracking-[0.15em] font-medium text-white/70 uppercase mb-4">
                        Our Sponsor
                    </p>

                    {/* Increased heading text size (text-[56px] and lg:text-[60px]) */}
                    <h2 className="text-[60px] md:text-[56px] lg:text-[60px] font-bold leading-[1.1] mb-6 text-white tracking-tight">
                        Celebrating <br />
                        Community With <br />
                        Our Proud Sponsor
                    </h2>

                    <p className="text-white/70 text-[16px] leading-[1.6] max-w-[600px]">
                        WamGlammz proudly collaborates with Irving Street Tapas, a
                        place that stands for culture, connection, and empowerment, just
                        like us. Irving Street Tapas Portland
                    </p>
                </div>

                {/* CENTER LOGO (FAINT WATERMARK) */}
                <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-0 hidden md:block pointer-events-none">
                    <img
                        src={watermarkLogo}
                        alt=""
                        className="w-[200px] md:w-[250px] lg:w-[320px] brightness-0 invert opacity-20"
                    />
                </div>

                {/* RIGHT COLUMN - SPONSOR CARD */}
                <div className="relative z-20 flex-shrink-0 flex flex-col items-center">
                    <div className="rounded-[16px] overflow-hidden">
                        <img
                            src={communityImg}
                            alt="Irving Street Tapas"
                            className="w-[300px] md:w-[380px] h-auto object-cover block"
                        />
                    </div>

                    {/* NEW TEXT BELOW IMAGE */}
                    <p className="mt-4 text-white text-[16px] font-medium text-center">
                        Restaurant & Private Event Space
                    </p>
                </div>
            </div>
        </section>
    );
}